import type { DeviceServiceEvent, DeviceServiceEventStateEnumKey } from '@emma/api_client/types';
import { Tag, Text } from '@lego/klik-ui';
import { dateTimeFormat } from '@/utility/date';
import { createColumnHelper } from '../appTable';

const stateColorScheme = (state: DeviceServiceEventStateEnumKey): string => {
  switch (state) {
    case 'RUNNING':
    case 'FINISHED':
    case 'INSTALLED':
      return 'success';
    case 'BROKEN':
    case 'ERRORED':
      return 'error';
    default:
      return 'warning';
  }
};

const columnHelper = createColumnHelper<DeviceServiceEvent>();

export const deploymentIssuesTableColumns = columnHelper.columns([
  columnHelper.accessor('state', {
    cell: (info) => (
      <Tag colorScheme={stateColorScheme(info.getValue())} size="sm">
        {info.getValue()}
      </Tag>
    ),
    header: 'State',
    size: 150,
  }),
  columnHelper.accessor('reason', {
    cell: (info) => <Text whiteSpace="normal">{info.getValue()}</Text>,
    header: 'Reason',
    size: 900,
  }),
  columnHelper.accessor('timestamp', {
    cell: (info) => (
      <Text fontFamily="mono" fontSize="sm">
        {new Date(info.getValue()).toLocaleString(dateTimeFormat.local)}
      </Text>
    ),
    header: 'Timestamp',
    size: 280,
  }),
]);
